import {Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, Resolve} from "@angular/router";
import {Observable} from "rxjs";
import {OrderService} from "../providers/order.service";
import {OrdersDgSearchResults} from "../models/datagrid-search-results/orders.dg-search-results.model";
import {AppStateService} from "../providers/app-state.service";
import {tap} from "rxjs/operators";
import {environment} from "../../environments/environment";

@Injectable()
export class OrdersResolve implements Resolve<OrdersDgSearchResults> {
  constructor(private orderService: OrderService, private appStateService: AppStateService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<OrdersDgSearchResults> {
    this.appStateService.updateIsBusySubject(true);
    let queryParam = route.queryParams['email'];
    if (queryParam !== undefined) {
      let map = new Map<string, string>();
      map.set("email", queryParam);

      console.log(map)

      return this.orderService.searchForResults(environment.DEFAULT_RESULTS_LIMIT, 0, map, 'DESC', 'created').pipe(tap(res => {
        this.appStateService.updateIsBusySubject(false);
      }));
    } else {
      return this.orderService.getResults(environment.DEFAULT_RESULTS_LIMIT, 0, 'DESC', 'created').pipe(tap(res => {
        this.appStateService.updateIsBusySubject(false);
      }));
    }
  }
}


